<template>
  <DataTable
    :value="listDataService"
    :lazy="true"
    class="p-datatable-responsive"
    selectionMode="single"
    data-key="id"
    @page="onPage($event)"
    :paginator="pagination"
    :totalRecords="totalRecords"
    :rows="paginationRows"
    :loading="loading"
    :scrollable="(scrollHeight !== '' ? true : false) "
    :scrollHeight="scrollHeight"
    :autoLayout="true"
    filterMatchMode="startsWith"
    :first="firstRecordIndex"
    :rowsPerPageOptions="$constants.LIST_OPTION_COMMON.PER_PAGE_OPTIONS"
    :currentPageReportTemplate=" $constants.LIST_OPTION_COMMON.TEXT_TOTAL_ITEM+' {totalRecords}'"
    :paginatorTemplate="$constants.LIST_OPTION_COMMON.PAGINATOR_TEMPLATE"
  >
    <Column 
      v-for="c in model.getDisplayFields()"
      :key="c.key"
      :field="getField(c)"
      :header="getLabel(c)"
      :ref="getField(c)"
      :filterMatchMode="getFilterMatch(c)"
      :sortable="getSortable(c)"
      :bodyClass="(c.class ? 'txt-' + c.class : '')"
      :bodyStyle="getHeaderStyle(c)"
      :headerStyle="getHeaderStyle(c)"
      :headerClass="(c.class ? 'txt-' + c.class : '')"
    >
      <template #body="slotProps">
        <!--{{c}}-->
        <img
          v-if="getType(c) == 'Image'"
          :src="getData(c, slotProps.data)"
          style="width: 40px; heigth: 40px"
        />
        <div
          v-else-if="c.type == 'Text'"
          v-html="getData(c, slotProps.data)"
          :style="(c.style ? c.style : '')"
        ></div>
        <div
          v-else-if="getType(c) == 'CustomData'"
          v-html="callbackCustom(c, slotProps.data)"
          :style="(c.style ? c.style : '')"
        ></div>
        <div
          v-else-if="getType(c) == 'Custom' || getType(c) == 'Icon'"
          v-html="getData(c, slotProps.data)"
          :style="(c.style ? c.style : '')"
        ></div>

        <Checkbox
          v-else-if="getType(c) == 'Checkbox'"
          v-model="slotProps.data[slotProps.column.field]"
          :binary="true"
          @change="onInputChange($event, slotProps.data, c)"
        />
        <div v-else>
          <div v-if="c.custom">
            <Avatar v-if="c.custom == 'image'" :image="getData(c, slotProps.data)" size="xlarge"  />
            <div v-if="c.custom == 'SelectionText'"  v-html="callbackDataSelect( c ,slotProps.data)"></div>

          </div>
          <span v-else v-html="getData(c, slotProps.data)" :class="getCustomClass(c, slotProps.data[c.key], slotProps.data)"></span>
        </div>

      </template>
      <template v-if="c.filter" #filter>
        <InputText
          v-if="c.filter.type == 'input'"
          type="text"
          v-model="filters[$CommonList.getFieldFilter(c)]"
          class="p-column-filter"
          :placeholder="getFilterPlaceHolder(c)"
          @keyup="onFilter($event,c.filter.type,c.key)"
          :style="getHeaderStyle(c)"
        /><!-- :keyup="onFilter(c.filter.type,c.key)"-->
        <!--v-model="filters[getField(c)]"-->
        <Dropdown
          :key="countDropdown"
          v-if="c.filter.type == 'select'"
          v-model="filters[getField(c)]"
          :options="getFilterOptions(c.key)"
          :optionLabel="c.filter.optionLabel"
          :optionValue="c.filter.optionKey"
          :placeholder="getFilterPlaceHolder(c)"
          class="p-column-filter"
          :showClear="true"
          appendTo="body"
          @change="onFilter($event,c.filter.type,c.key)"
          :style="getHeaderStyle(c)"
        >
          <template #option="slotProps">
            <div class="p-clearfix">
              <span
                :class="getCustomClass(c, slotProps.option[c.filter.optionKey], slotProps.data)"
                >{{ slotProps.option[c.filter.optionLabel] }}</span
              >
            </div>
          </template>
        </Dropdown>
        <Calendar 
          v-if="c.filter.type == 'DateRange'"
          :showOnFocus="false" 
          :monthNavigator="true" 
          :yearNavigator="true" 
          yearRange="2020:2300" 
          dateFormat="dd-mm-yy" 
           
          v-model="filters[getField(c)]"
          class="p-column-filter"
          :showIcon="true" 
          selectionMode="range"
          appendTo="body"
          :showClear="true"
          :showButtonBar="true"
          @clear-click="onFilter($event,c.filter.type,c.key)"
          @date-select="onFilter($event,c.filter.type,c.key)"
          :manualInput="false"
          style="width: 200px;"
          />
      </template>
    </Column>
    <Column
      v-if="actions"
      headerStyle="width: 10em; text-align: center"
      bodyStyle="width: 10em; text-align: center"
    >
      <template #body="slotProps">
        <span class="p-column-title">Actions</span>
        {{ slotProps.data.color }}
        <Button
          v-for="(a, k) in actions.rows(slotProps.data)"
          :key="k"
          type="button"
          :icon="getIcon(a.icon)"
          :class="getClass(a.name)"
          :disabled="getDisabled(a.disabled)"
          style="margin: 2px"
          v-on:click="actionsClicked(k, a, slotProps)"
        ></Button>
      </template>
      <template #header="slotProps">
        <Button
          v-if="actions.header"
          type="button"
          :icon="getIcon(actions.header.icon)"
          :class="getClass(actions.header.name)"
          v-on:click="actionsClicked(actions.header.name, actions.header, slotProps)"
        ></Button>
      </template>
    </Column>
    <template #empty>
      {{ $t('datatable.empty') }}
    </template>
    <template #loading>
      {{ $t('datatable.loading') }}
    </template>
  </DataTable>
</template>

<script>
import moment from "moment-timezone";
//import gql from "graphql-tag";
import DataServices from "@/core/DataServices";
export default {
  props: {
    model: Object,
    tableData: Array,
    getFilterOptions: Function,
    actions: Object,
    options: Array,
    whereKeyList: Object,
  },
  data() {
    return {
      //filters: {},
      countDropdown: 0,
      pagination: true, // true cho phép phân trang
      paginationRows: this.$constants.LIST_OPTION_COMMON.PAGINATION_ROWS_DEFAULT, // số dòng trên 1 trang
      scrollHeight: '', // chiều cao của trang danh sách
      loading: true,
      rowsPerPageOptions: [10, 20, 50, 100],
      first: 0,
      totalRecords: 120,
      totalRecords2: 12,
      test: null,
      listDataService:null,
      filters: {},
      filtersCustom: [],
      lazyParams: {},
      page_transaction:null,
      firstRecordIndex:0,
      time_zone_local : moment.tz.guess(),
    };
  },
  
  async created() {
    // console.log("modelmodelmodelmodelmodelmodelmodelmodelmodel:",this.model)
    // console.log(this.tableData);
    this.test = this.tableData;
    //this.listDataService = await this.dataList();
  },
  mounted () {
    this.lazyParams = {
      first: 0,
      rows: this.paginationRows,
      sortField: null,
      sortOrder: null,
      filters: this.filters,
    //  filtersTmp:this.filters
    };
    if (!this.$commonFuction.isEmpty(this.$route.query)){
      if (!this.$commonFuction.isEmpty(this.$route.query.page_transaction)){
        this.page_transaction = this.$route.query.page_transaction;
        this.lazyParams = (localStorage.getItem(this.page_transaction)) ? JSON.parse(localStorage.getItem(this.page_transaction)) : {};
        console.log("this.lazyParamsthis.lazyParams:"+this.page_transaction,this.lazyParams);
         this.firstRecordIndex = this.lazyParams.first;
        console.log("this.lazyParams:22222222",this.lazyParams);
       /* if (this.lazyParams){
          console.log("this.lazyParams.filters",this.lazyParams.filters);

        }*/
      }
    }
    this.loading = false
    this.countDropdown++;
    this.onLazyEvent();
  },
  methods: {
    select_date(event,col_name) {
      if (this.filters[col_name][0] !== null && this.filters[col_name][1] !== null) {
        this.$emit("filter_date", {
          data: this.filters[col_name],
          col: col_name
        });
      }
    },
    getLabel(col) {
      if (col.label) return col.label;
      else return col.name;
    },
    getType(col) {
      if (col.display?.list?.mode == "custom") {
        return "Custom";
      }
      switch (col.type) {
        case "String":
        case "Text":
        case "Computed":
          if (col.inputOptions?.mode == "Image") {
            return "Image";
          }
          if (col.inputOptions?.mode == "selection") {
            return "Select";
          }
          if (col.inputOptions?.mode == "currency") {
            return "Currency";
          }
          if(col.inputOptions?.mode == 'icon') {
            return "Icon";
          }
          return "Input";
        case "numeric":
        case "ShadowField":
        case "number":
          if (col.inputOptions?.mode == "currency") {
            return "Currency";
          } else if (col.inputOptions?.mode == "percentage") {
            return "Percentage";
          } else {
            return "Number";
          }
        case "Selection":
          return "Select";
        case "Checkbox":
          return "Checkbox";
        default:
          return col.type;
      }
    },
    cannotEdit(col) {
      if (col.edit && col.edit.edit == false) return true;
      return false;
    },
    onInputChange(value, data, f) {
      if (f.onChange)  f.onChange(data).bind(this);
      this.$emit("onDataChange", data, f);
    },
    toggle(event) {
      this.$refs.op.toggle(event);
    },
    getCustomClass(col, data, rowData) {
      if (col.displayClass) return col.displayClass(data, rowData);
      return "";
    },
    getField(col) {
      return col.key;
    },
    getHeaderStyle(col) {
      var style = "";
      if (col.width) style = "width: " + col.width + "em !important;";
      else if (col.name === "stt" || col.name === "STT") style = "width: 3em;";
      else if (col.type === "image" || col.type === "Image") style = "width: 6em;";
      return style;
    },
    getData(col, row) {
      //console.log("colcolcol:",col);
      //console.log("rowrowrowrow:",row);
      var value = '';
      if (col.type == "Date" && row[col.key]) {
        value = moment.tz(row[col.key], this.time_zone_local).format("DD/MM/yyyy");
      } else if (col.type == "Datetime" && row[col.key]) {
        value = moment.tz(row[col.key], this.time_zone_local).format("ll HH:mm");
      } else if (col.type == "CustomDate" && row[col.key]) {
        value = moment.tz(row[col.key], this.time_zone_local).format("HH:mm - DD/MM/yyyy");
      } else if(col.type == "Hour" && row[col.key]){
        value = moment.tz(row[col.key], this.time_zone_local).format("HH:mm");
      } else if (col.type == "Selection") {
        var lists = [];
        if (col.options !== undefined) {
          lists = col.options;
        } else if (col.models !== undefined && this.options[col.key] !== undefined) {
          lists = this.options[col.key];
        }
        if (lists && lists.length) {
          var objResult = lists.filter(a => a.value == row[col.key]);
          if (objResult !== undefined && Object.keys(objResult) && Object.entries(objResult).length) {
            value = objResult[Object.keys(objResult)].label;
          }
        }
      } else {
        if (col.type == "Text" && row[col.key] && row[col.key].length > 100) {
          var result = row[col.key].substr(0, row[col.key].lastIndexOf(" ", 100)) + "...";
          value = result;
        }
        if (this.getType(col) == "Currency") {
          if (row[col.key] == null) row[col.key] = 0;
          value = this.formatCurrency(row[col.key]);
        }
        if (this.getType(col) == "Percentage") {
          if (row[col.key] == null) row[col.key] = `0%`;
          value = row[col.key] + "%";
        }
        value = row[col.key];
      }
      if (col.style) value = '<abbr style="' + col.style + '">' + value + '<abbr/>';
      else if (col.options) {
        var filtered = col.options.filter( a => a.value  === row[col.key]);
        if (Object.keys(filtered) && Object.entries(filtered).length && filtered[0].style) {
          value = '<abbr style="' + filtered[0].style + '">' + value + '<abbr/>';
        }
      } 
      return value
    },
    getFilterMatch(col) {
      var filterMatch = "startWith";
      if (col.filter && col.filter.match) {
        filterMatch = col.filter.match;
      }
      return filterMatch;
    },
    getFilterPlaceHolder(col) {
      if (col.filter.placeHolder) {
        return col.filter.placeHolder;
      } else if (col.filter.type == "select") {
        if(col.name=='active'){
          return ``;
        }
        return `Choose`;
      } else if (col.filter.type == "input") {
        return `Input`;
      } else {
        return ``;
      }
    },
    getSortable(col) {
      return col.sortable && col.sortable == true ? true : false;
    },
    getIcon(iconName) {
      return `pi pi-${iconName}`;
    },
    getDisabled(disabled = false) {
      return disabled;
    },
    actionsClicked(key, action, rowData) {
      this.$emit("action-click", {
        originalEvent: event,
        action: action,
        key: key,
        data: rowData,
        lazyParams:this.lazyParams
      });
    },
    getClass(type) {
      switch (type) {
        case "add":
          return "p-button-add";
        case "delete":
          return "p-button-danger";
        case "edit":
          return "p-button-edit";
        case "adddebt":
          return "p-button-edit"
        case "add-Debt":
          return "p-button-add";
        case "editcustom":
          return "p-button-edit"
        case "addcustom":
          return "p-button-add";
      }
    },
    formatCurrency(value) {
      return value.toLocaleString("vi-VN", {
        style: "currency",
        currency: "VND"
      });
    },
   async dataList(lazyParams) {
      // console.log('lazyParams');
      // console.log('lazyParams:',lazyParams);
     var offset = lazyParams.first;
     var limit = lazyParams.rows;
     
     var gqLQueryList = DataServices.getList(this.model.tableName);
     var where = {
      deleted: {_eq: false},
      _or : [
        {clubs_id : {_is_null : true}},
        {
          clubs : {
            deleted : {_eq : false}
          }
        }
      ]
     }
     var filters = lazyParams.filters;
     if (filters){
       for (const [key, value] of Object.entries(filters)) {
        //  console.log("dsadsd",value.type_input);
         if (value.type_input == 'input'){
            if (!this.$commonFuction.isEmpty(value.value)){
              if (key == 'creator'){
                where['creator'] = {
                  'plain_fullname' :{_ilike: "%"+this.$commonFuction.SkipVN(value.value)+"%"}
                };
              }else if (key == 'email'){
                where['email'] = {_ilike: "%"+this.$commonFuction.SkipVN(value.value)+"%"};
              }else if (key == 'title'){
                where['plain_title'] = {_ilike: "%"+this.$commonFuction.SkipVN(value.value)+"%"};
              }else if (key == 'caption'){
                where['plain_caption'] = {_ilike: "%"+this.$commonFuction.SkipVN(value.value)+"%"};
              }else if (key == 'clubs_name'){
                where['clubs'] = {
                  club_plainname : {_ilike: "%"+this.$commonFuction.SkipVN(value.value)+"%"}
                };
              }else if (key == 'match_info'){
                where["match"] = {
                  stadium : {
                    plain_name : {_ilike: "%"+this.$commonFuction.SkipVN(value.value)+"%"}
                  }
                } 
              }
              else if(key=='main_areas'){
                var txtt = this.$commonFuction.SkipVN(value.value)
                where['_or'] = [
                  {
                    type : {_eq : 'APPLYING_TO_JOIN'},
                    text_main_active : {_ilike : "%"+txtt+"%"}
                  },
                  {
                    type : {_in : ['MATCH','SHOWING_OFF_YOUR_EQUIPMENT','QUESTION']},
                    creator : {
                      text_main_active : {_ilike : "%"+txtt+"%"}
                    }
                  },
                  {
                    type : {_eq : 'LIFE'},
                    _or :[
                      {
                        is_community : {_eq : true},
                        // "dk của clubs"
                        _or : [{
                            clubs : {
                              province : {
                                "province_lang": {
                                  "lang":{"_eq": "en"},
                                  "plain_name": {"_like": "%"+txtt+"%"}
                                }
                              }
                            }
                          },{
                            clubs : {
                              district : {
                                "district_lang": {
                                  "lang":{"_eq": "en"},
                                  "plain_name": {"_like": "%"+txtt+"%"}
                                }
                              }
                            },
                          },{
                            clubs : {
                              country : {
                                "country_lang": {
                                  "lang":{"_eq": "en"},
                                  "plain_name": {"_like": "%"+txtt+"%"}
                                }
                              }
                            }
                          }
                        ]
                      },
                      {
                        is_community : {_eq : false},
                        creator : {
                          text_main_active : {_ilike : "%"+txtt+"%"}
                        }
                      },
                    ]
                  },
                  {
                    type : {_in : ['LOOKING_FOR_A_TEAM','LOOKING_FOR_MERCENARY','SCOUT_CLUB_TEAM_MEMBER','POST_ON_MY_CLUB']},
                    _or : [{
                      clubs : {
                        province : {
                          "province_lang": {
                            "lang":{"_eq": "en"},
                            "plain_name": {"_like": "%"+txtt+"%"}
                          }
                        }
                      }
                    },{
                      clubs : {
                        district : {
                          "district_lang": {
                            "lang":{"_eq": "en"},
                            "plain_name": {"_like": "%"+txtt+"%"}
                          }
                        }
                      },
                    },{
                      clubs : {
                        country : {
                          "country_lang": {
                            "lang":{"_eq": "en"},
                            "plain_name": {"_like": "%"+txtt+"%"}
                          }
                        }
                      }
                    }]
                  },
                  
                ]
                // where['post_main_area'] = {
                //   "_or": [
                //     {
                //       "province_lang": {
                //         "lang":{"_eq": "en"},
                //         "plain_name": {"_like": "%"+txtt+"%"}
                //       }
                //     },
                //     {
                //       "district_lang": {
                //         "lang":{"_eq": "en"},
                //         "plain_name": {"_like": "%"+txtt+"%"}
                //       }
                //     }
                //   ]
                // }
              }
              else {
                where[key] = {_like: "%"+value.value+"%"};
              }

            }
         }
         else if(value.type_input == 'select'){
            // console.log("filters",filters)
            if(key == "active"){
              if(value.value !== undefined && value.value !== null){
                where['active'] = {_eq: value.value}
              }
            }else if(key == "deleted"){
              if(value.value !== undefined && value.value !== null){
                where['deleted'] = {_eq: value.value}
              }
            }
            else if(key == "type_login"){
              if(value.value !== undefined && value.value !== null){
                where.accounts['type'] = {_eq: value.value}
              }
            }else{
              if(value.value !== undefined && value.value !== null){
                where[key] = {_eq: value.value}
              }
            }
          }else if (value.type_input == 'DateRange'){
            if(key == 'created_at'){
              if(value.value !== undefined && value.value !== null){
                where['created_at'] = {'_gte': value.value.from,'_lt': value.value.to}
              }
            }else{
              if(value.value !== undefined && value.value !== null){
                where[key] = {'_gte': value.value.from,'_lt': value.value.to}
              }
            }
            
          }
       }

     }
     var resData = await this.$apollo.mutate({
       mutation: gqLQueryList,
       variables: {
         where_key:where ,
         offset:offset,
         limit:limit,
         orderBy:{created_at: 'desc'}
       }
     });
     var listData = resData.data[this.model.tableName];

     var gqLQueryCount = DataServices.countData(this.model.tableName);
     var countRes = await this.$apollo.mutate({
       mutation: gqLQueryCount,
       variables: {
         where_key:where
       }
     });
     var total = countRes.data[this.model.tableName+'_aggregate']['aggregate']['count'];

     var dataRes = {
       listData: listData,
       total: total,
     };
    //  console.log('dataRes:',dataRes);
     return dataRes;
    },

    
    onLazyEvent() {
      this.lazyParams.filters = this.filtersCustom;
      // console.log('this.lazyParams:', this.lazyParams)
      this.loading = true;
      var that = this;
      this.dataList(this.lazyParams).then(data => {
        //var count = 0;
        if (data.listData.length < 1) {
          that.listDataService = data.listData;
          that.totalRecords = data.total;
          that.loading = false;
        }
        var stt = this.lazyParams.first;
        for (var i = 0; i < data.listData.length; i++) {
          stt++;
          data.listData[i].stt = stt;
          if(data.listData[i].accounts && data.listData[i].accounts.length > 0){
            data.listData[i].type_login = data.listData[i].accounts[0].type
          }else{
            data.listData[i].type_login = 'EMAIL'
          }
          var title = data.listData[i].title
          var caption = data.listData[i].caption
          if(title){
            data.listData[i].title = `<span class="block-ellipsis-2">`+title+`</span>`
          }
          if(caption){
            data.listData[i].caption = `<span class="block-ellipsis-3">`+caption+`</span>`
          }
        }
        that.listDataService = data.listData;
        that.totalRecords = data.total;
        that.loading = false;
      });
    },

    callbackCustom(c,data){
      var text = ''
      switch(c.key) {
        case 'creator':
          if(data.creator){
            text = data.creator.fullname
          }
          break;
        case 'clubs_name':
          if(data.clubs){
            text = data.clubs.club_name
          }
          break;
        case 'match_info':
          if(data.match){
            text = moment.tz(data.match.date_time, this.time_zone_local).format("ll HH:mm");
              if(data.match.stadium){
              if(text !== ''){
                text += ", "+data.match.stadium.name
              }else{
                text = data.match.stadium.name
              }
            }
          }
          break
        case 'main_areas':
          if(data.type == 'APPLYING_TO_JOIN'){
            // text = data.text_main_active ? data.text_main_active : ''
            if(data.post_main_area.length > 0){
              var map = []
              var province_id_map = []
              var tmp = data.post_main_area
              for (let i = 0; i < tmp.length; i++) {
                const e = tmp[i];
                if(e.district_id == null){
                  let name_province = e.province.province_lang ? e.province.province_lang[0].name : ''
                  let name_country = e.province.country ? e.province.country.country_lang[0].name : ''
                  if(name_province !== ''){
                    if(!province_id_map.includes(e.province_id)){
                      province_id_map.push(e.province_id)
                    }
                    map[e.province_id]={
                      province_id : e.province_id,
                      name: name_province,
                      is_all: true,
                      name_districts : '',
                      name_country : name_country
                    }
                  }
                }else{
                  if(province_id_map.includes(e.province_id)){
                    var checkdata = map[e.province_id]
                    if(checkdata.is_all == false){
                      let name_district = e.district.district_lang ? e.district.district_lang[0].name : ''
                      if(name_district !== ''){
                        map[e.province_id].name_district += '-'+name_district
                      }
                    }
                  }else{
                    let name_province = e.province.province_lang ? e.province.province_lang[0].name : ''
                    let name_district = e.district.district_lang ? e.district.district_lang[0].name : ''
                    let name_country = e.province.country ? e.province.country.country_lang[0].name : ''
                    if(name_province !=='' && name_district!==''){
                      province_id_map.push(e.province_id);
                      map[e.province_id]={
                        province_id : e.province_id,
                        name: name_province,
                        is_all: false,
                        name_district: name_district,
                        name_country : name_country
                      }
                    }
                  }
                }
              }
              if(province_id_map.length > 0){
                for (let j = 0; j < province_id_map.length; j++) {
                  var data_tmp = map[province_id_map[j]]
                  if(data_tmp.is_all == true){
                    if(text !== ''){
                      text += '; '+data_tmp.name+','+data_tmp.name_country
                    }else{
                      text = data_tmp.name+','+data_tmp.name_country
                    }
                  }else{
                    if(text !== ''){
                      text += '; '+data_tmp.name_district+','+data_tmp.name+','+data_tmp.name_country
                    }else{
                      text += data_tmp.name_district+','+data_tmp.name+','+data_tmp.name_country
                    }
                  }
                }
              }
            }
            if(text.length > 105){
              text = text.slice(0,105)+'...'
            }
          }else if(data.type == 'LOOKING_FOR_A_TEAM' || data.type == 'LOOKING_FOR_MERCENARY' || data.type == 'SCOUT_CLUB_TEAM_MEMBER' || data.type == 'POST_ON_MY_CLUB' || (data.type == 'LIFE' && data.is_community == true)){
            if(data.clubs){
              if(data.clubs.district){
                text = data.clubs.district.district_lang[0].name
              }
              if(data.clubs.province){
                if(text !== ''){
                  text += ','+data.clubs.province.province_lang[0].name
                }else{
                  text =  data.clubs.province.province_lang[0].name
                }
              }
              if(data.clubs.country){
                if(text !== ''){
                  text += ','+data.clubs.country.country_lang[0].name
                }else{
                  text = data.clubs.country.country_lang[0].name
                }
              }
            }
          }else{
            // text = data.creator.text_main_active ? data.creator.text_main_active : ''
            if(data.users_main_area.length > 0){
              let map = []
              let province_id_map = []
              let tmp = data.users_main_area
              for (let i = 0; i < tmp.length; i++) {
                const e = tmp[i];
                if(e.district_id == null){
                  let name_province = e.province.province_lang ? e.province.province_lang[0].name : ''
                  let name_country = e.province.country ? e.province.country.country_lang[0].name : ''
                  if(name_province !== ''){
                    if(!province_id_map.includes(e.province_id)){
                      province_id_map.push(e.province_id)
                    }
                    map[e.province_id]={
                      province_id : e.province_id,
                      name: name_province,
                      is_all: true,
                      name_districts : '',
                      name_country : name_country
                    }
                  }
                }else{
                  if(province_id_map.includes(e.province_id)){
                    let checkdata = map[e.province_id]
                    if(checkdata.is_all == false){
                      let name_district = e.district.district_lang ? e.district.district_lang[0].name : ''
                      if(name_district !== ''){
                        map[e.province_id].name_district += '-'+name_district
                      }
                    }
                  }else{
                    let name_province = e.province.province_lang ? e.province.province_lang[0].name : ''
                    let name_district = e.district.district_lang ? e.district.district_lang[0].name : ''
                    let name_country = e.province.country ? e.province.country.country_lang[0].name : ''
                    if(name_province !=='' && name_district!==''){
                      province_id_map.push(e.province_id);
                      map[e.province_id]={
                        province_id : e.province_id,
                        name: name_province,
                        is_all: false,
                        name_district: name_district,
                        name_country : name_country
                      }
                    }
                  }
                }
              }
              if(province_id_map.length > 0){
                for (let j = 0; j < province_id_map.length; j++) {
                  let data_tmp = map[province_id_map[j]]
                  if(data_tmp.is_all == true){
                    if(text !== ''){
                      text += '; '+data_tmp.name+','+data_tmp.name_country
                    }else{
                      text = data_tmp.name+','+data_tmp.name_country
                    }
                  }else{
                    if(text !== ''){
                      text += '; '+data_tmp.name_district+','+data_tmp.name+','+data_tmp.name_country
                    }else{
                      text += data_tmp.name_district+','+data_tmp.name+','+data_tmp.name_country
                    }
                  }
                }
              }
            }
            if(text.length > 105){
              text = text.slice(0,105)+'...'
            }
          }
          break;
        default:
          break;
      }
      return text;
    },

    callbackDataSelect(c,data){
      var text = "";
      switch(c.key) {
        case 'type_login':
          if(data.type_login == 'EMAIL'){
            text += 'Email';
          }else if(data.type_login == 'FACEBOOK'){
            text += 'Facebook';
          }else if(data.type_login == 'APPLE'){
            text += 'Apple ID';
          }else if(data.type_login == 'GOOGLE'){
            text += 'Google';
          }
          break;
        case 'status':
          if(data.status == 'actived'){
            text += `<span style="color:#007ad9;"><i class="pi pi-check" style="font-size: 20px;font-weight: 900;"></i></span>`; 
          }
          break;
        case 'active':
          if(data.active == true){
            text = `<i  style="color: green" class="pi pi-check icon"></i>`;
          }else{
            text = `<i style="color: red" class="pi pi-times icon"></i>`;
          }
          break;

        case 'deleted':
          if (data.deleted === true){
            text += `<span style="color:red;"><i class="pi pi-check" style="font-size: 20px;font-weight: 900;"></i></span>`; 
          }
          break;
        default:
      }
      return text;
    },


    onPage(event) {
      console.log("eventeventeventevent",event);
      this.lazyParams = event;
      this.onLazyEvent();
    },
    async onFilter(event,type_input,key) {
      //this.loading = true;
      this.tableData = this.test;
      
      this.filtersCustom[key] = await this.$CoreService.convertFilter(type_input,key,this.filters);

      this.lazyParams.first = 0;
      this.onLazyEvent()
      /*setTimeout(() => {
        this.customers = this.datasource.slice(event.first, event.first + event.rows);
        this.loading = false;
      }, 500);*/
    },
  }
};
</script>
<style lang="scss">
.p-paginator-bottom{padding: 0 !important;}
.txt-mid{
  text-align: center!important;
}
.block-ellipsis-2 {
  display: block;
  display: -webkit-box;
  max-width: 100%;
  /* margin: 0 auto; */
  line-height: 1.5;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
.block-ellipsis-3 {
  display: block;
  display: -webkit-box;
  max-width: 100%;
  /* margin: 0 auto; */
  line-height: 1.5;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>